<div class="flex flex-col min-h-screen">
    <nav class="sticky z-20 top-0 left-0 w-full bg-secondary-content-bright">
        <div class="relative container mx-auto justify-center flex flex-row p-4 lg:pt-8 lg:pb-8 h-full">
            <app-logo></app-logo>
        </div>
    </nav>


    <main class="container mx-auto p-8 flex-grow">

        <div *ngIf="state === interfaceState.CARD_ENTRY; then cardEntry"></div>
        <div *ngIf="state === interfaceState.ERROR; then errorHandling"></div>
        <div *ngIf="state === interfaceState.SUCCESS; then cardData"></div>
        <div *ngIf="state === interfaceState.LOADING; then loadingDiv"></div>


        <ng-template #loadingDiv>
            <div class="flex card-base relative text-center items-center justify-center mx-auto">
                <div class="low-band-absolute"></div>
            </div>
            <app-loader></app-loader>
        </ng-template>

        <ng-template #cardEntry>
            <app-card-entry [cardId]="cardId" (onFieldsPairUpdate)="onFieldsChange($event)"></app-card-entry>
        </ng-template>

        <ng-template #errorHandling>
            <app-card-error [errorMessage]="errorMessage"></app-card-error>
        </ng-template>

        <ng-template #cardData>

            <div *ngIf="cardStatusErrorMessage; else cardInfo">
                <app-card-error [errorMessage]="cardStatusErrorMessage" [showsRetryButton]="false"></app-card-error>
            </div>

            <ng-template #cardInfo>
                <app-card-info [lookupObject]="lookupObject"></app-card-info>
            </ng-template>
            
        </ng-template>

    </main>

    <app-footer></app-footer>
</div>